.root {
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  text-align: right;
}

.flexColumnWrapper {
  display: flex;
  flex-direction: column;
}

.verticalLineDivider {
  height: 32px;
  width: 1px;
  background-color: var(--border-default);
}
